import { Card, CardContent, Typography, Box, keyframes, Skeleton } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const shine = keyframes`
  0% { left: -100%; }
  20% { left: 120%; }
  100% { left: 120%; }
`;
const formatValue = (value, type) => {
  if (value === null || value === undefined) return '-';

  switch (type) {
    case 'rupees':
      return `₹ ${Number(value).toLocaleString('en-IN')}`;
    case 'dollar':
      return `$ ${Number(value).toLocaleString('en-US')}`;
    case 'number':
      return Number(value).toLocaleString();
    case 'string':
    default:
      return value;
  }
};

const CardModule = ({ title = 'Title', value = '0', type, color, loading, defalutColor }) => {
  const defaultColorSet = defalutColor || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
  if (loading) {
    return (
      <Skeleton
        variant="rectangular"
        height="120px" // Approximate height of the card content including padding
        sx={{ borderRadius: '16px' }}
      />
    );
  }

  return (
    <Card
      elevation={3}
      sx={{
        height: '100%',
        background: color || defaultColorSet,
        borderRadius: '16px',
        transition: 'box-shadow 0.9s ease-in-out',
        '&:hover': {
          boxShadow: '0 10px 20px rgba(0,0,0,0.2)',
          '&::after': {
            animation: `${shine} 3s infinite linear`, // Repeats the shine effect
          },
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: '-100%',
          width: '50%',
          height: '100%',
          background: 'linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.3) 100%)',
          transform: 'skewX(-25deg)',
          pointerEvents: 'none',
        },
        color: '#fff', // Assuming the colors passed are dark/vibrant enough for white text. If not, we might need a prop for textColor.
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '100px',
          height: '100px',
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '50%',
          transform: 'translate(30%, -30%)',
        }}
      />

      <CardContent sx={{ position: 'relative', zIndex: 1, padding: '24px' }}>
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 500,
            fontSize: '1rem',
            opacity: 0.9,
            mb: 1,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="h4"
          component="div"
          sx={{
            fontWeight: 'bold',
            letterSpacing: '0.5px',
          }}
        >
          {formatValue(value, type)}
        </Typography>
      </CardContent>
    </Card>
  );
};

CardModule.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  color: PropTypes.string,
  loading: PropTypes.bool,
};

export default React.memo(CardModule);
 